import React, { useState, useCallback } from "react";
import "./With.css";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ContractDetails from "../../Contracts/ContractDetails";
import Change from "../../Common/StringToSub";
import { Container, Row, Col } from "react-bootstrap";
import { BiFilter } from "react-icons/bi";
import { GrPowerReset } from "react-icons/gr";
import CopyComponent from "../../Component/CopyComponent/CopyComponent";
import PaginationComponent from "../../Component/Pagination/PaginationControls";
import moment from "moment";
import debounce from "lodash.debounce";
import { HiDownload } from "react-icons/hi";
import { Modal, Button } from "react-bootstrap";
import Popup from "reactjs-popup";
import { ethers } from "ethers";
import GetChainId from "../../Common/GetChainId";
import getAddress from "../../Common/GetAddress";
import { parse } from "url";
import apiCall from "../../API/API";
import { toast } from "react-toastify";

const PriPendingWith = () => {
  const [data, setData] = useState([]);
  const [paymentRequests, setPaymentRequests] = useState({
    data: [],
    totalPages: 1,
    debitSum: 0,
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filter, setFilter] = useState("none");
  const [selectedToken, setSelectedToken] = useState();
  const [companyDetails, setCompanyDetails] = useState();
  const [show, setShow] = useState(false);
  const [search, setsearch] = useState({
    source: "principal_withdrawal",
    status: "0",
    principal_withdrawal_immediate_amount: "",
    username: "",
    search: "",
    startDate: "",
    endDate: "",
    uid: "",
  });
  const [limitFilter, setLimitFilter] = useState(20);
  const [dateFilter, setDateFilter] = useState("default");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [showRejectionReason, setShowRejectionReason] = useState(false);
  const [currentTxId, setCurrentTxId] = useState(null);
  const [rejectionReason, setRejectionReason] = useState("");
  const [showApproveAllModal, setShowApproveAllModal] = useState(false);
  const [currentApproveTxId, setCurrentApproveTxId] = useState(null);
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [tx_hash, setTxHash] = useState("");
  const [tx_Ids, setTx_Ids] = useState([]);
  const [walletAddress, setWalletADdress] = useState([]);
  const [amount, setAmount] = useState([]);
  const [username, setUsername] = useState([]);
  const [token, setToken] = useState([]);
  const [tokenSymbol, setTokenSymbol] = useState([]);
  const [value, setValue] = useState();
  const [currentRowData, setCurrentRowData] = useState(null);

  const { BigInt } = window;

  // Fetch all transactions function - Updated to use /get-payment-transaction endpoint
  const fetchAllTransaction = async (params) => {
    try {
      setLoading(true);
      const queryParams = new URLSearchParams();

      // Add all parameters to query string
      Object.keys(params).forEach((key) => {
        if (
          params[key] !== undefined &&
          params[key] !== null &&
          params[key] !== ""
        ) {
          queryParams.append(key, params[key]);
        }
      });

      const response = await apiCall(
        "GET",
        `/get-payment-transaction?${queryParams.toString()}`,
        null,
        false
      );

      if (response.data) {
        setPaymentRequests(response.data);
        setTotalPages(response.data.totalPages || 1);
      }
    } catch (error) {
      console.error("Error fetching transactions:", error);
      toast.error("Failed to fetch transactions");
    } finally {
      setLoading(false);
    }
  };

  // Approve withdrawal requests function
  // const approveWithdrawalRequests = async (txIds, reason = "", allTxIds = []) => {
  //   try {
  //     setLoading(true);
  //     const body = {
  //       requestIds: txIds
  //     }
  //     console.log("API call: approve1111111111111111111", body);
  //     const response = await apiCall(
  //       "POST",
  //       "/approve_principal_withdrawal_immediate",
  //        body,
  //        true
  //     );
  //     console.log("API response:", response);
  //     if (response.data) {
  //       toast.success("Withdrawal requests approved successfully");
  //       return response.data;
  //     }
  //   } catch (error) {
  //     console.error("Error approving withdrawal requests:", error);
  //     toast.error("Failed to approve withdrawal requests");
  //     throw error;
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const approveWithdrawalRequests = async (txIds) => {
    try {
      setLoading(true);

      const body = {
        requestIds: txIds,
      };

      console.log("API call payload (JSON):", body);
      // const { data, error: apiError } = await apiCall('POST', '/verify_2fa', { token: otp });
      const { data, error: apiError } = await apiCall(
        "POST",
        "/approve_principal_withdrawal_immediate",
        body,
        true
      );

      console.log("API response:", data);
      console.log("API apiError:", apiError);

      // if (response.data) {
      //   toast.success("Withdrawal requests approved successfully");
      //   return response.data;
      // }
    } catch (error) {
      console.error("Error approving withdrawal requests:", error);
      // toast.error("Failed to approve withdrawal requests");
      throw error;
    } finally {
      setLoading(false);
    }
  };

  // Reject withdrawal request function
  const rejectWithdrawalRequest = async (txIds, reason) => {
    try {
      setLoading(true);
      const response = await apiCall(
        "POST",
        "/reject-withdrawal-request",
        {
          tx_ids: txIds,
          reason: reason,
        },
        true
      );

      if (response.data) {
        toast.success("Withdrawal requests rejected successfully");
        return response.data;
      }
    } catch (error) {
      console.error("Error rejecting withdrawal requests:", error);
      toast.error("Failed to reject withdrawal requests");
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const fetchWithdraw = useCallback(
    debounce((params) => {
      fetchAllTransaction(params);
    }, 500),
    []
  );

  const toggleFilter = () => {
    if (filter === "none") {
      setFilter("flex");
    } else {
      setFilter("none");
    }
  };

  const handlePagination = (page) => {
    setCurrentPage(page);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "startDate") {
      setStartDate(value);
    } else if (name === "endDate") {
      setEndDate(value);
    } else {
      setsearch((prev) => {
        const updatedSearch = { ...prev, [name]: value };
        Object.keys(updatedSearch).forEach((key) => {
          if (updatedSearch[key] === "" || updatedSearch[key] === 0) {
            delete updatedSearch[key];
          }
        });
        return updatedSearch;
      });
    }
    fetchWithdraw({
      page: currentPage,
      limit: limitFilter,
      ...Object.fromEntries(
        Object.entries(search).filter(
          ([_, value]) => value !== "" && value !== 0
        )
      ),
      ...(startDate && endDate ? { startDate, endDate } : {}),
    });
  };

  const handleLimitChange = (e) => {
    setLimitFilter(e.target.value);
  };

  const handleDateFilterChange = (e) => {
    const value = e.target.value;
    setDateFilter(value);
    const today = moment().endOf("day");
    let start = "";
    let end = "";
    switch (value) {
      case "today":
        start = today.startOf("day").format("YYYY-MM-DD");
        end = today.format("YYYY-MM-DD");
        break;
      case "yesterday":
        start = today.subtract(1, "days").startOf("day").format("YYYY-MM-DD");
        end = today.endOf("day").format("YYYY-MM-DD");
        break;
      case "this_week":
        start = today.startOf("week").format("YYYY-MM-DD");
        end = today.endOf("week").format("YYYY-MM-DD");
        break;
      case "this_month":
        start = today.startOf("month").format("YYYY-MM-DD");
        end = today.endOf("month").format("YYYY-MM-DD");
        break;
      default:
        start = "";
        end = "";
        break;
    }
    setStartDate(start);
    setEndDate(end);
  };

  const Addfilter = () => {
    const queryParams = {
      page: currentPage,
      limit: limitFilter,
      ...Object.fromEntries(
        Object.entries(search).filter(
          ([_, value]) => value !== "" && value !== 0
        )
      ),
    };

    if (startDate) {
      queryParams.startDate = startDate;
    }
    if (endDate) {
      queryParams.endDate = endDate;
    }

    fetchAllTransaction(queryParams);
  };

  const resetFilter = () => {
    setsearch({
      source: "principal_withdrawal",
      status: "0",
      principal_withdrawal_immediate_amount: "",
      username: "",
      search: "",
      startDate: "",
      endDate: "",
      uid: "",
    });
    setLimitFilter(20);
    setStartDate("");
    setEndDate("");
    setDateFilter("default");
    setCurrentPage(1);

    fetchAllTransaction({
      page: 1,
      limit: 20,
      source: "principal_withdrawal",
      status: "0",
    });
  };

  useEffect(() => {
    const queryParams = {
      page: currentPage,
      limit: 20,
      ...Object.fromEntries(
        Object.entries(search).filter(
          ([_, value]) => value !== "" && value !== 0
        )
      ),
    };
    if (startDate && endDate) {
      queryParams.startDate = startDate;
      queryParams.endDate = endDate;
    }
    fetchWithdraw(queryParams);
  }, [currentPage, limitFilter, search, startDate, endDate]);

  useEffect(() => {
    setTotalPages(paymentRequests?.totalPages);
  }, [paymentRequests]);

  const toggleSelectAll = () => {
    setSelectAll(!selectAll);
    if (!selectAll) {
      const allIds = paymentRequests?.data?.map((row) => row?.tx_Id) || [];
      setSelectedRows(allIds);
      setTx_Ids(allIds);
      setWalletADdress(
        paymentRequests?.data?.map((row) => row?.account?.address)
      );
      setAmount(paymentRequests?.data?.map((row) => row?.withdrawal_amount));
      setUsername(paymentRequests?.data?.map((row) => row?.username));
      setToken(paymentRequests?.data?.map((row) => row?.token_address));
      setTokenSymbol(paymentRequests?.data?.map((row) => row?.token_symbol));
    } else {
      setSelectedRows([]);
      setTx_Ids([]);
      setWalletADdress([]);
      setAmount([]);
      setUsername([]);
      setToken([]);
      setTokenSymbol([]);
    }
  };

  const toggleSelectRow = (tx_Id, address, amt, user) => {
    if (selectedRows.includes(tx_Id)) {
      setSelectedRows(selectedRows.filter((id) => id !== tx_Id));
      setTx_Ids(tx_Ids.filter((id) => id !== tx_Id));
      setWalletADdress(walletAddress?.filter((addr) => addr !== address));
      setAmount(amount?.filter((a) => a !== amt));
      setUsername(username?.filter((u) => u !== user));
    } else {
      setSelectedRows([...selectedRows, tx_Id]);
      setTx_Ids([...tx_Ids, tx_Id]);
      setWalletADdress([...walletAddress, address]);
      setAmount([...amount, amt]);
      setUsername([...username, user]);
    }
  };

  const handleWithDap = () => {
    navigate("/dashboard/principal_withdrawal_details", {
      state: {
        amountArray: amount,
        walletAddressArray: walletAddress,
        usernameArray: username,
        tx_IdsArray: tx_Ids,
      },
    });
  };

  const handleApproveAllClick = () => {
    setShowApproveAllModal(true);
  };

  const handleApproveAll = async () => {
    try {
      if (!tx_hash || tx_hash.trim() === "") {
        alert("Please enter transaction hash before approving all.");
        return;
      }
      await approveWithdrawalRequests(tx_Ids, tx_hash.trim(), tx_Ids);
      setShowApproveAllModal(false);
      fetchAllTransaction({
        page: 1,
        limit: 20,
        source: "principal_withdrawal",
        status: "0",
      });
      // Reset selections
      setSelectedRows([]);
      setTx_Ids([]);
      setWalletADdress([]);
      setAmount([]);
      setUsername([]);
      setToken([]);
      setTokenSymbol([]);
      setSelectAll(false);
    } catch (e) {
      console.log(e);
    }
  };

  const handleCancelApproveAll = () => {
    setShowApproveAllModal(false);
    setTxHash("");
  };

  const handleConfirmApprove = (tx_Id, rowData) => {
    console.log("rowData", rowData);

    setCurrentApproveTxId(tx_Id);
    setCurrentRowData(rowData);
    setShowApproveModal(true);
  };

  const handleCancelApprove = () => {
    setShowApproveModal(false);
    setCurrentApproveTxId(null);
    setCurrentRowData(null);
    setTxHash("");
  };

  const handleApprove = async () => {
    try {
      if (!tx_hash || tx_hash.trim() === "") {
        alert("Please enter transaction hash before approving.");
        return;
      }
      console.log("Approving tx:", currentApproveTxId);
      await approveWithdrawalRequests([currentApproveTxId], tx_hash.trim(), [
        currentApproveTxId,
      ]);
      setCurrentApproveTxId(null);
      setShowApproveModal(false);
      setTxHash("");
      fetchAllTransaction({
        page: 1,
        limit: 20,
        source: "principal_withdrawal",
        status: "0",
      });
    } catch (e) {
      console.log("Approve error:", e);
    }
  };

  const handleRejectAll = () => {
    setShowRejectionReason(true);
  };

  const handleReject = (tx_Id) => {
    setCurrentTxId(tx_Id);
  };

  const handleSaveRejectionReason = async () => {
    try {
      await rejectWithdrawalRequest(tx_Ids, rejectionReason);
      setShowRejectionReason(false);
      setRejectionReason("");
      fetchAllTransaction({
        page: 1,
        limit: 20,
        source: "principal_withdrawal",
        status: "0",
      });
      // Reset selections
      setSelectedRows([]);
      setTx_Ids([]);
      setWalletADdress([]);
      setAmount([]);
      setUsername([]);
      setToken([]);
      setTokenSymbol([]);
      setSelectAll(false);
    } catch (e) {
      console.log(e);
    }
  };

  const handleSaveReason = async () => {
    try {
      await rejectWithdrawalRequest([currentTxId], rejectionReason);
      setCurrentTxId(null);
      setRejectionReason("");
      fetchAllTransaction({
        page: 1,
        limit: 20,
        source: "principal_withdrawal",
        status: "0",
      });
    } catch (e) {
      console.log(e);
    }
  };

  const getCompanyDetails = async () => {
    try {
      const res = await apiCall("GET", "/get-company-info");
      console.log("company details", res);
      setCompanyDetails(res?.data?.company_info);
    } catch (error) {
      console.error(error.message);
    }
  };

  const handleToken = (token) => {
    console.log("token details", token);
    setSelectedToken(token);
    setShow(false);
  };

  useEffect(() => {
    if (selectedToken) {
      if (value == "all") {
        handleApproveAll();
      } else if (value == "single") {
        handleApprove();
      }
    }
  }, [selectedToken]);

  var x = 0;
  useEffect(() => {
    if (x == 0) {
      getCompanyDetails();
      x++;
    }
  }, []);

  const handleApproveSelection = (value, tx_Id) => {
    setValue(value);
    setCurrentApproveTxId(tx_Id);
    setShow(true);
  };

  return (
    <React.Fragment>
      <Container>
        {show && (
          <div className="popup-overlay">
            <div className="popup-container">
              <h2>Select Token For Withdrawal</h2>
              <div className="tokenSelection">
                {companyDetails?.tokens
                  ?.filter((token) => token.enabled === 1)
                  ?.map((token, i) => (
                    <div
                      key={i}
                      className="tokenDiv"
                      onClick={() => handleToken(token)}
                    >
                      <span>{token?.tokenName}</span>
                      {token?.token_image?.startsWith("<svg") ? (
                        <span
                          style={{ marginLeft: "5px" }}
                          dangerouslySetInnerHTML={{
                            __html: token?.token_image,
                          }}
                        />
                      ) : (
                        <img
                          src={token?.token_image}
                          alt={token?.tokenSymbol}
                          style={{ marginLeft: "5px", height: "40px" }}
                        />
                      )}
                    </div>
                  ))}
              </div>
            </div>
          </div>
        )}

        <div className="pagePath">
          <h4 className="m-0">Pending Principal Withdrawal</h4>
        </div>
        <Row id="filterRow">
          <span className="filterL">
            <div className="d-flex justify-content-between">
              <div onClick={() => toggleFilter()}>
                <i>
                  <BiFilter />
                </i>
                Filter
              </div>
              <div className="align-content-center">
                Total Debited Amount :{" "}
                {paymentRequests?.debitprincipalImmediateSum}
              </div>
            </div>
          </span>

          <Row className="p-0 m-0" style={{ display: filter }}>
            <Col lg="2" md="4">
              <div>
                <input
                  type="text"
                  name="search"
                  placeholder="Search By Name, Username"
                  value={search.search}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <input
                  type="text"
                  placeholder="Search User By Uid"
                  name="uid"
                  value={search.uid}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <input
                  type="number"
                  name="amount"
                  placeholder="Search By Amount"
                  value={search.principal_withdrawal_immediate_amount}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <input
                  type="date"
                  name="startDate"
                  placeholder="Start Date"
                  value={startDate}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <input
                  type="date"
                  name="endDate"
                  placeholder="End Date"
                  value={endDate}
                  onChange={handleChange}
                />
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <select
                  name="dateFilter"
                  value={dateFilter}
                  onChange={handleDateFilterChange}
                >
                  <option value="default">Default</option>
                  <option value="today">Today</option>
                  <option value="yesterday">Yesterday</option>
                  <option value="this_week">This Week</option>
                  <option value="this_month">This Month</option>
                </select>
              </div>
            </Col>
            <Col lg="2" md="4">
              <div>
                <select
                  name=""
                  value={limitFilter}
                  onChange={handleLimitChange}
                >
                  <option value="">--All--</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                </select>
              </div>
            </Col>
            <div>
              <button className="save filter" onClick={Addfilter}>
                Filter{" "}
                <i>
                  <BiFilter />
                </i>
              </button>
              <button className="cancel reset" onClick={resetFilter}>
                Reset{" "}
                <i>
                  <GrPowerReset />
                </i>
              </button>
            </div>
          </Row>
        </Row>
        <div id="directIncomeDiv">
          <div className="button-container">
            <button
              className="action-btn"
              onClick={handleWithDap}
              disabled={loading}
            >
              Approve With Dap
            </button>
            <button
              className="action-btn"
              onClick={handleApproveAllClick}
              disabled={loading}
            >
              Approve All
            </button>
          </div>
          <Modal show={showApproveAllModal} onHide={handleCancelApproveAll}>
            <Modal.Header closeButton>
              <Modal.Title>Confirm Approve All</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div>
                <p>
                  Are you sure you want to approve all selected transactions?
                </p>
                <label style={{ display: "block", marginTop: "8px" }}>
                  Transaction Hash (tx_hash):
                </label>
                <input
                  type="text"
                  value={tx_hash}
                  onChange={(e) => setTxHash(e.target.value)}
                  placeholder="Enter transaction hash"
                  style={{ width: "100%" }}
                />
                <small style={{ color: "#666" }}>
                  Provide the blockchain transaction hash for this batch
                  approve.
                </small>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCancelApproveAll}>
                Cancel
              </Button>
              <Button
                variant="primary"
                onClick={handleApproveAll}
                disabled={loading}
              >
                {loading ? "Approving..." : "Approve All"}
              </Button>
            </Modal.Footer>
          </Modal>
          {showRejectionReason && (
            <div className="rejection-reason-container">
              <button
                className="close-btn1"
                onClick={() => setShowRejectionReason(false)}
              >
                x
              </button>
              <div className="reject-container">
                <input
                  type="text"
                  placeholder="Enter rejection reason"
                  value={rejectionReason}
                  onChange={(e) => setRejectionReason(e.target.value)}
                  className="rejection-reason-input"
                />
                <button
                  className="save-btn"
                  onClick={handleSaveRejectionReason}
                  disabled={loading}
                >
                  {loading ? "Saving..." : "Save"}
                </button>
              </div>
            </div>
          )}
          <Row id="directTableRow" className="text-center">
            <Col md="12" className="p-0">
              <div style={{ width: "100%", display: "flex" }}>
                <table>
                  <tr>
                    <th>
                      <div className="checkbox-cell">
                        <input
                          type="checkbox"
                          checked={selectAll}
                          onChange={toggleSelectAll}
                          className="checkbox-input"
                          id="selectAll"
                        />
                        <label htmlFor="selectAll" className="checkbox-label">
                          <span
                            className={`custom-checkbox ${
                              selectAll ? "checked" : ""
                            }`}
                          />
                          <span className="checkbox-text">Select All</span>
                        </label>
                      </div>
                    </th>
                    <th>S. No.</th>
                    <th>Name</th>
                    <th>Username</th>
                    <th>Uid</th>
                    <th>Account Details</th>
                    <th>Requested Amount</th>
                    <th>Hash Code</th>
                    <th>Status</th>
                    <th>Date</th>
                  </tr>
                  {loading ? (
                    <tr>
                      <td
                        colSpan="9"
                        style={{ textAlign: "center", padding: "20px" }}
                      >
                        Loading...
                      </td>
                    </tr>
                  ) : (
                    paymentRequests?.data?.map((row, index) => (
                      <tr key={index}>
                        <td>
                          <div className="checkButton">
                            <input
                              type="checkbox"
                              checked={selectedRows.includes(row.tx_Id)}
                              onChange={() =>
                                toggleSelectRow(
                                  row.tx_Id,
                                  row?.account?.address.trim(),
                                  row?.principal_withdrawal_immediate_amount,
                                  row?.username
                                )
                              }
                              className="checkbox-input"
                              id={`row-${index}`}
                            />
                            <label
                              htmlFor={`row-${index}`}
                              className="checkbox-label1"
                            >
                              <span
                                className={`custom-checkbox ${
                                  selectedRows.includes(row.tx_Id)
                                    ? "checked"
                                    : ""
                                }`}
                              />
                            </label>
                            <div className="button-container1">
                              <button
                                className="action-btn1"
                                onClick={() =>
                                  handleConfirmApprove(row.tx_Id, row)
                                }
                                disabled={loading}
                              >
                                ✓
                              </button>
                            </div>
                          </div>
                        </td>
                        <td>{index + 1 + 20 * (currentPage - 1)}</td>
                        <td>{row.name}</td>
                        <td>{row.username}</td>
                        <td>{row?.uid}</td>
                        <td>
                          <div className="keyValue">
                            {row?.account?.address}
                            <CopyComponent value={row?.account?.address} />
                          </div>
                        </td>
                        <td>
                          {parseFloat(
                            row.principal_withdrawal_immediate_amount
                          ).toFixed(2)}
                        </td>
                        <td>
                          {row.tx_hash === "manual approval" ? (
                            "manual approval"
                          ) : (
                            <a
                              href={`https://bscscan.com/tx/${row.tx_hash}`}
                              target="_blank"
                            >
                              {row.tx_hash}
                            </a>
                          )}
                        </td>
                        {row.status == 0 ? (
                          <td>Pending</td>
                        ) : row.status == 1 ? (
                          <td>Approved</td>
                        ) : (
                          <td>Rejected</td>
                        )}
                        <td>{moment(row?.createdAt).format("lll")}</td>
                      </tr>
                    ))
                  )}
                </table>
              </div>
            </Col>
          </Row>
        </div>
        <Row>
          <Col md="12">
            {
              <PaginationComponent
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePagination}
              />
            }
          </Col>
        </Row>
        <Modal show={showApproveModal} onHide={handleCancelApprove}>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Approval</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Are you sure you want to approve this transaction?</p>
            {currentRowData && (
              <>
                <p>Name: {currentRowData.name}</p>
                <p>Username: {currentRowData.username}</p>
                <p>
                  Amount:{" "}
                  {parseFloat(
                    currentRowData.principal_withdrawal_immediate_amount ||
                      currentRowData.amount
                  ).toFixed(2)}
                </p>
              </>
            )}
            <label style={{ display: "block", marginTop: "8px" }}>
              Transaction Hash (tx_hash):
            </label>
            <input
              type="text"
              value={tx_hash}
              onChange={(e) => setTxHash(e.target.value)}
              placeholder="Enter transaction hash"
              style={{ width: "100%" }}
            />
            <small style={{ color: "#666" }}>
              Enter the blockchain transaction hash for this approval.
            </small>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCancelApprove}>
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={handleApprove}
              disabled={loading}
            >
              {loading ? "Approving..." : "Approve"}
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </React.Fragment>
  );
};

export default PriPendingWith;
